<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="achat_ouinon"
      :live="liveSociete(25927)"
      v-model="sasSociete.declarerLAchatDUneOuDePlusieursPharmacies"
      ref="achatOuiNon"
      :disabled="!estSocieteProprietaire"
    />
    <data-iterator
      :list="sas.achatsPharmacie"
      add-new-text="Ajouter une pharmacie"
      :live="{ endpoint: 'sas-achat-pharmacie', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
      hidePoints
      :opqIf="conditionAchat"
    >
      <template v-slot:show-mode="{ item }">
        <OrganisationCardContent v-if="item.organisation" :organisation="item.organisation" />
      </template>
      <template v-slot:edit-mode="{ item }">
        <SearchPharmacie
          v-if="!item.organisation"
          @organisation-selected="organisationSelected(item, $event)"
          :idToExclude="sas.achatsPharmacie.filter((x) => x.organisation).map((x) => x.organisation.organisationId)"
        ></SearchPharmacie>
        <OrganisationCardContent v-if="item.organisation" :organisation="item.organisation" />
        <v-checkbox
          class="list_counter_validator my-2 ml-6 p-0"
          :input-value="!!item.organisation"
          :rules="[(v) => !!v || 'Veuillez sélectionner une pharmacie']"
        ></v-checkbox>
        <DatePickerLive code="achat_date" v-model="item.dateDAchat" :live="liveSasAchat(26306, item)" :minValue="serverDate()" />
        <FileInput
          code="ouverture_bail_ou_titrepropriete"
          :file="item.documentsJustificatifs"
          :live="liveSasAchat(26303, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
        />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent.vue"
import { Queue, Api } from "@/plugins/api"
import SearchPharmacie from "@/components/Formulaires/DemandeEnregistrementSociete/component/SearchPharmacie.vue"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  components: { OrganisationCardContent, SearchPharmacie },
  props: {
    sas: { type: Object }
  },
  methods: {
    organisationSelected(item, org) {
      Queue.enqueue(() =>
        Api.post("sas-achat-pharmacie", {
          fileId: item.id,
          cle: "300",
          value: org.organisationId
        }).then(() => {
          item.organisation = org
        })
      )
    },
    liveSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    liveSasAchat(cle, item) {
      return { endpoint: "sas-achat-pharmacie", cle: cle, fileId: item.id }
    },
    desactiverAjout() {
      if (!this.estSocieteProprietaire) {
        this.$refs.achatOuiNon.setValueByCode("N")
      } else {
        this.sasSociete.declarerLAchatDUneOuDePlusieursPharmacies = null
      }
    }
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionAchat() {
      return this.estOui(this.sas.sasSociete.declarerLAchatDUneOuDePlusieursPharmacies) && this.estSocieteProprietaire
    },
    estSocieteProprietaire() {
      return this.getCatalogueCodeById("335", this.sas.sasSociete.categorieDeSociete) !== "spnp"
    }
  }
}
</script>

<style></style>